import axios from 'axios';
const httpClient = axios.create();

export const useZengaApi = (baseUrl) => {
	const getAdverts = (advertIds) =>
		httpClient.get(`${baseUrl}/adverts/cards`, {
			params: {
				'filter[advertId]': advertIds
			},
			paramsSerializer: (param) => new URLSearchParams(param).toString()
		});
	const getLocationList = (nameFragment) => httpClient.get(`${baseUrl}/adverts/search/locations`, { params: { nameFragment } });

	return { getAdverts, getLocationList };
};
